export default `
    <div style="background: url('/images/snippetsMedia/defaultBanner.png'); background-position: 50%; background-size: cover; width: 100%; height: 100vh"></div>
  `;
